import React from "react";
import {
    RiArrowDownLine, RiArrowDropDownFill, RiArrowDropUpFill, RiArrowUpLine,
} from "@remixicon/react";
import Button from "../button/Button";
import Styles from "./SortBy.module.scss";
import { useTheme } from "../../../contexts/Theme";

export enum Direction {
    ASCENDING,
    DESCENDING
}

export default function SortUpDown({
    onChange,
    direction,
    variant,
}: {
    onChange: (direction: Direction) => void;
    direction: Direction | undefined;
    variant?: "small" | "buttons"
}) {
    const theme = useTheme();
    const createOnClick = (value: Direction) => (event: React.MouseEvent) => {
        event.stopPropagation();
        onChange(value);
    };
    const isSmall = variant === "small";
    const buttonVariant = isSmall ? "secondary" : "primary";
    const selectedVariant = theme.isV3 && isSmall ? "none" : undefined;

    return (
        <div className={Styles[`btn-sort-style-${variant}`]}>
            <Button
                size="small"
                className={Styles["btn-sort-order"]}
                variant={selectedVariant ?? (direction === Direction.ASCENDING ? buttonVariant : "ghost-gray")}
                isActive={direction === Direction.ASCENDING}
                prefixIcon={theme.isV3 && isSmall ? <RiArrowDropUpFill /> : <RiArrowUpLine />}
                onClick={createOnClick(Direction.ASCENDING)}
                title="Ascending"
            />
            <Button
                size="small"
                className={Styles["btn-sort-order"]}
                variant={selectedVariant ?? (direction === Direction.DESCENDING ? buttonVariant : "ghost-gray")}
                onClick={createOnClick(Direction.DESCENDING)}
                title="Descending"
                isActive={direction === Direction.DESCENDING}
                prefixIcon={theme.isV3 && isSmall ? <RiArrowDropDownFill /> : <RiArrowDownLine />}
            />
        </div>
    );
}

SortUpDown.defaultProps = {
    variant: "small",
};
